(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (() => {
    const drawer = document.getElementById('filters-drawer');
    if (!drawer?.classList.contains('nobo-filters-drawer')) return;

    const mobileQuery = window.matchMedia('(max-width: 749px)');
    const desktopDrawerQuery = window.matchMedia('(min-width: 990px)');
    const dialog = drawer.querySelector('.theme-drawer__dialog');
    const filters = drawer.querySelector('.facets-drawer__filters');
    const wrapper = drawer.querySelector('.facets__filters-wrapper');
    const actions = drawer.querySelector('.facets__drawer-actions');
    if (!dialog || !filters || !wrapper || !actions) return;

    const dialogTop = 62;
    const minimumHeight = 320;
    let scheduled = false;
    let desktopScrollScheduled = false;
    let lockedMinimumHeight = 0;
    let lockedUntil = 0;
    let summaryScrollTop = null;

    function getScrollRoot() {
      return document.querySelector('.page-wrapper') || document.scrollingElement || document.documentElement;
    }

    function updateDesktopScrollbarWidth() {
      if (!desktopDrawerQuery.matches) {
        drawer.style.removeProperty('--nobo-filter-scrollbar-width');
        return;
      }

      const scrollRoot = getScrollRoot();
      const scrollbarWidth = Math.max(0, scrollRoot.offsetWidth - scrollRoot.clientWidth);
      drawer.style.setProperty('--nobo-filter-scrollbar-width', `${scrollbarWidth}px`);
    }

    function updateDesktopDrawerHeight() {
      if (!desktopDrawerQuery.matches) {
        dialog.style.removeProperty('--nobo-filters-desktop-height');
        return;
      }

      const dialogRect = dialog.getBoundingClientRect();
      const actionStyles = window.getComputedStyle(actions);
      const actionMarginBottom = parseFloat(actionStyles.marginBottom) || 0;
      const contentHeight = Math.ceil(actions.getBoundingClientRect().bottom - dialogRect.top + actionMarginBottom);

      if (contentHeight > 0) {
        dialog.style.setProperty('--nobo-filters-desktop-height', `${contentHeight}px`);
      }
    }

    function getDesktopDrawerScrollBounds() {
      const scrollRoot = getScrollRoot();
      const rootRect =
        scrollRoot === document.scrollingElement || scrollRoot === document.documentElement
          ? { top: 0, height: window.innerHeight }
          : scrollRoot.getBoundingClientRect();
      const dialogRect = dialog.getBoundingClientRect();
      const dialogTop = scrollRoot.scrollTop + dialogRect.top - rootRect.top;
      const dialogHeight = Math.max(dialog.scrollHeight, dialog.offsetHeight, dialogRect.height);
      const viewportHeight = scrollRoot.clientHeight || rootRect.height || window.innerHeight;
      const maxScroll = Math.max(0, Math.ceil(dialogTop + dialogHeight - viewportHeight));

      return { scrollRoot, maxScroll };
    }

    function getWheelDeltaY(event) {
      if (event.deltaMode === WheelEvent.DOM_DELTA_LINE) return event.deltaY * 16;
      if (event.deltaMode === WheelEvent.DOM_DELTA_PAGE) return event.deltaY * window.innerHeight;

      return event.deltaY;
    }

    function handleDesktopDrawerWheel(event) {
      if (!desktopDrawerQuery.matches || !drawer.hasAttribute('open') || !dialog.open) return;
      if (Math.abs(event.deltaY) <= Math.abs(event.deltaX)) return;

      updateDesktopDrawerHeight();

      const { scrollRoot, maxScroll } = getDesktopDrawerScrollBounds();
      const currentScroll = scrollRoot.scrollTop;
      const targetScroll = currentScroll + getWheelDeltaY(event);

      if (targetScroll < 0) {
        event.preventDefault();
        scrollRoot.scrollTop = 0;
      } else if (targetScroll > maxScroll) {
        event.preventDefault();
        scrollRoot.scrollTop = maxScroll;
      }
    }

    function clampDesktopDrawerScroll() {
      desktopScrollScheduled = false;

      if (!desktopDrawerQuery.matches || !drawer.hasAttribute('open') || !dialog.open) return;

      updateDesktopDrawerHeight();

      const { scrollRoot, maxScroll } = getDesktopDrawerScrollBounds();

      if (scrollRoot.scrollTop > maxScroll) {
        scrollRoot.scrollTop = maxScroll;
      }
    }

    function scheduleDesktopDrawerScrollClamp() {
      if (desktopScrollScheduled) return;
      desktopScrollScheduled = true;
      requestAnimationFrame(clampDesktopDrawerScroll);
    }

    function updateDrawerHeight() {
      scheduled = false;

      if (!mobileQuery.matches) {
        dialog.style.removeProperty('--nobo-filters-mobile-height');
        updateDesktopScrollbarWidth();
        updateDesktopDrawerHeight();
        scheduleDesktopDrawerScrollClamp();
        return;
      }

      dialog.style.removeProperty('--nobo-filters-desktop-height');

      const availableHeight = Math.max(minimumHeight, window.innerHeight - dialogTop);
      const filtersTop = filters.offsetTop || 147;
      const actionStyles = window.getComputedStyle(actions);
      const actionMarginTop = parseFloat(actionStyles.marginTop) || 0;
      const actionMarginBottom = parseFloat(actionStyles.marginBottom) || 0;
      const contentHeight =
        filtersTop + wrapper.scrollHeight + actionMarginTop + actions.offsetHeight + actionMarginBottom;
      const activeMinimumHeight = Date.now() < lockedUntil ? lockedMinimumHeight : minimumHeight;
      const targetHeight = Math.min(Math.max(contentHeight, activeMinimumHeight), availableHeight);

      dialog.style.setProperty('--nobo-filters-mobile-height', `${Math.ceil(targetHeight)}px`);
      scheduleDesktopDrawerScrollClamp();
    }

    function scheduleDrawerHeightUpdate(delay = 0) {
      if (scheduled) return;
      scheduled = true;
      window.setTimeout(() => requestAnimationFrame(updateDrawerHeight), delay);
    }

    function scheduleDrawerHeightUpdates() {
      scheduleDrawerHeightUpdate();
      window.setTimeout(scheduleDrawerHeightUpdate, 120);
      window.setTimeout(scheduleDrawerHeightUpdate, 320);
      window.setTimeout(scheduleDrawerHeightUpdate, 520);
    }

    drawer.addEventListener('mousedown', (event) => {
      const target = event.target instanceof Element ? event.target : null;

      if (target?.closest('.facets__summary')) {
        summaryScrollTop = getScrollRoot().scrollTop;
        event.preventDefault();
      }
    });

    drawer.addEventListener('click', (event) => {
      const target = event.target instanceof Element ? event.target : null;

      if (!target?.closest('.facets__summary') || summaryScrollTop === null) return;

      const scrollTop = summaryScrollTop;
      summaryScrollTop = null;
      const restoreScrollPosition = () => {
        getScrollRoot().scrollTop = scrollTop;
      };

      requestAnimationFrame(restoreScrollPosition);
      window.setTimeout(restoreScrollPosition, 120);
      window.setTimeout(restoreScrollPosition, 320);
      window.setTimeout(restoreScrollPosition, 520);
    });

    drawer.addEventListener(
      'click',
      (event) => {
        if (!mobileQuery.matches) return;

        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        const checkbox = target.closest('.nobo-filter-options--two-columns .checkbox');
        if (!checkbox || target.matches('.checkbox__input')) return;

        const input = checkbox.querySelector('.checkbox__input');
        if (!input || input.disabled) return;

        event.preventDefault();
        input.checked = !input.checked;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        const currentHeight = dialog.getBoundingClientRect().height;
        lockedMinimumHeight = Math.max(minimumHeight, currentHeight);
        lockedUntil = Date.now() + 700;
        scheduleDrawerHeightUpdates();
      },
      true
    );

    drawer.addEventListener('click', scheduleDrawerHeightUpdates);
    drawer.addEventListener(
      'toggle',
      () => {
        scheduleDrawerHeightUpdates();
      },
      true
    );
    window.addEventListener('resize', scheduleDrawerHeightUpdate);
    document.addEventListener('wheel', handleDesktopDrawerWheel, { passive: false });
    getScrollRoot().addEventListener('scroll', scheduleDesktopDrawerScrollClamp, { passive: true });
    mobileQuery.addEventListener('change', scheduleDrawerHeightUpdate);
    desktopDrawerQuery.addEventListener('change', scheduleDesktopDrawerScrollClamp);

    new MutationObserver(scheduleDrawerHeightUpdate).observe(dialog, {
      attributes: true,
      attributeFilter: ['open', 'style'],
    });

    new MutationObserver(scheduleDesktopDrawerScrollClamp).observe(dialog, {
      attributes: true,
      childList: true,
      subtree: true,
    });

    if ('ResizeObserver' in window) {
      new ResizeObserver(scheduleDesktopDrawerScrollClamp).observe(dialog);
      new ResizeObserver(scheduleDrawerHeightUpdate).observe(wrapper);
      new ResizeObserver(scheduleDrawerHeightUpdate).observe(actions);
    }

    document.addEventListener('theme-drawer:open', (event) => {
      if (event.target === drawer) {
        updateDesktopScrollbarWidth();
        scheduleDrawerHeightUpdate();
        scheduleDesktopDrawerScrollClamp();
      }
    });

    updateDesktopScrollbarWidth();
    scheduleDrawerHeightUpdate();
    scheduleDesktopDrawerScrollClamp();
  })();
  } catch(e) { console.error(e); }
})();

})();
